import * as React from 'react';

export const customTags: Set<string> = new Set([
  "LOGIN",
  "CONT",
  "LINE",
  "DECOR",
  "INK",
  "BORDER",
  "MESSAGE",
  "EDGE",
  "EDGE_COVER",
  "VIEW",
  "ICON",
  "SEPARATOR",
  "LOGO",
  "INFO",
  "CONTAINER",
  "HORIZONAL_WRAP",
  "CONTENT",
  "CONTENT_WRAP",
  "TEXT_LABEL",
  "TEXT",
  "CHECK",
  "BOX",
  "WRAP",
  "LIST",
  "ITEM",
  "OVERLAY",
  "GRID",
  "SCROLLER",
  "BLOCK",
  "SPACE",
  "PICTURE",
  "DEMOSPACE",
  "NAME",
  "BADGE",
  "GROUP",
  "DASHBOARD",
  "SUBTITLE",
  "SWITCH",
  "SWITCHABLE",
  "PLAYER",
  "PLAYLIST",
  "MEDIA",
  "CIRCLE",
  "LINE",
  "ROW",
  "INFOBAR",
  "THUMB",
  "DETAIL",
  "COVER",
  "CONTROLS",
  "DECOR",
  "DECORATION",
  "DOT",
  "GAP",
  "PIE",
  "TIP",
  "COL",
  "COUNT",
  "TEST",
  "ZONE",
  "LAYOUT",
  "TAG",
  "ACTION",
  "ELASTIC",
  "TOOLBAR",
  "COMMANDBAR",
  "PANEL",
  "WRAPPER",
  "WIDGET",
  "DEMO_WRAP",
  "APPLICATION",
  "THUMBS",
  "POINT",
  "HOLDER",
  "CYCLE",
  "TICK",
  "ALERT",
  "DISTRIBUTION",
  "HAMBURGER",
  "PULSE",
  "SIGNATURE",
  "SLIDER",
  "SLIDE",
  "BACK",
  "ERRORMESSAGE",
  "MATERIAL",
]);

// declare global {
//   // eslint-disable-next-line @typescript-eslint/no-namespace
//   namespace JSX {
//     interface IntrinsicElements {
//       [action: string]: any;
//       [alert: string]: any;
//       [application: string]: any;
//       [badge: string]: any;
//       [block: string]: any;
//       [box: string]: any;
//       [check: string]: any;
//       [circle: string]: any;
//       [col: string]: any;
//       [cont: string]: any;
//       [line: string]: any;
//       [decor: string]: any;
//       [ink: string]: any;
//       [border: string]: any;
//       [container: string]: any;
//       [content_wrap: string]: any;
//       [controls: string]: any;
//       [count: string]: any;
//       [cover: string]: any;
//       [cycle: string]: any;
//       [dashboard: string]: any;
//       [decor: string]: any;
//       [demo_wrap: string]: any;
//       [demospace: string]: any;
//       [detail: string]: any;
//       [distribution: string]: any;
//       [dot: string]: any;
//       [elastic: string]: any;
//       [errormessage: string]: any;
//       [gap: string]: any;
//       [sidesgap: string]: any;
//       [grid: string]: any;
//       [group: string]: any;
//       [holder: string]: any;
//       [horizonal_wrap: string]: any;
//       [icon: string]: any;
//       [info: string]: any;
//       [infobar: string]: any;
//       [item: string]: any;
//       [layout: string]: any;
//       [line: string]: any;
//       [list: string]: any;
//       [login: string]: any;
//       [logo: string]: any;
//       [media: string]: any;
//       [message: string]: any;
//       [name: string]: any;
//       [overlay: string]: any;
//       [panel: string]: any;
//       [picture: string]: { rotate?: any };
//       [pie: string]: any;
//       [player: string]: any;
//       [playlist: string]: any;
//       [point: string]: any;
//       [pulse: string]: any;
//       [row: string]: any;
//       [scroller: string]: any;
//       [subtitle: string]: any;
//       [separator: string]: { horizontal?: any };
//       [space: string]: any;
//       [span: string]: { large?: any };
//       // [switch: string]: any;
//       [switchable: string]: any;
//       [tag: string]: any;
//       [test: string]: any;
//       [text: string]: any;
//       [thumb: string]: any;
//       [thumbs: string]: any;
//       [tick: string]: any;
//       [tip: string]: any;
//       [toolbar: string]: { main?: any };
//       [view: string]: React.DetailedHTMLProps<
//         React.HTMLAttributes<HTMLDivElement>,
//         HTMLDivElement
//       >;
//       [widget: string]: any;
//       [wrap: string]: any;
//       [wrapper: string]: any;
//       [zone: string]: any;
//       [hamburger: string]: any;
//       [dashboard: string]: any;
//       [length: string]: any;
//       [preline: string]: any;
//       [monospace: string]: any;
//       [size: string]: any;
//       [slide: string]: any;
//       [slider: string]: any;
//       [material: string]: any;
//     }
//   }
// }

const nativeTostring = Object.prototype.toString;
// toString override added to prototype of Custom class
// eslint-disable-next-line
Object.prototype.toString = function () {
  //NOSONAR
  const tag = this as HTMLElement;
  try {
    if (customTags.has(tag.tagName)) {
      return `[object ${tag.tagName}]`;
    }
    // eslint-disable-next-line no-empty
  } catch {}

  return nativeTostring.call(this);
};

declare module "react/jsx-runtime" {
  namespace JSX {
    interface IntrinsicElements {
      "action": React.HTMLAttributes<HTMLElement>;
      "alert": React.HTMLAttributes<HTMLElement>;
      "application": React.HTMLAttributes<HTMLElement>;
      "badge": React.HTMLAttributes<HTMLElement>;
      "block": React.HTMLAttributes<HTMLElement>;
      "box": React.HTMLAttributes<HTMLElement>;
      "check": React.HTMLAttributes<HTMLElement>;
      "cont": {
        s?: string | boolean;
      } & React.HTMLAttributes<HTMLElement>;
      "ink": React.HTMLAttributes<HTMLElement>;
      "border": React.HTMLAttributes<HTMLElement>;
      "container": React.HTMLAttributes<HTMLElement>;
      "content_wrap": React.HTMLAttributes<HTMLElement>;
      "controls": React.HTMLAttributes<HTMLElement>;
      "count": React.HTMLAttributes<HTMLElement>;
      "cover": React.HTMLAttributes<HTMLElement>;
      "cycle": React.HTMLAttributes<HTMLElement>;
      "decor": React.HTMLAttributes<HTMLElement>;
      "demo_wrap": React.HTMLAttributes<HTMLElement>;
      "demospace": React.HTMLAttributes<HTMLElement>;
      "detail": React.HTMLAttributes<HTMLElement>;
      "distribution": React.HTMLAttributes<HTMLElement>;
      "dot": React.HTMLAttributes<HTMLElement>;
      "elastic": React.HTMLAttributes<HTMLElement>;
      "errormessage": React.HTMLAttributes<HTMLElement>;
      "gap": React.HTMLAttributes<HTMLElement>;
      "sidesgap": React.HTMLAttributes<HTMLElement>;
      "grid": React.HTMLAttributes<HTMLElement>;
      "group": { 
        direction?: string;
        ratio?: string;
        gap?: string;
        key?: React.Key | string | undefined | null;
        ref?: React.RefObject<HTMLDivElement | null> | React.Ref<HTMLDivElement> | undefined;
      } & React.HTMLAttributes<HTMLElement>;
      "holder": React.HTMLAttributes<HTMLElement>;
      "horizonal_wrap": React.HTMLAttributes<HTMLElement>;
      "icon": React.HTMLAttributes<HTMLElement>;
      "info": React.HTMLAttributes<HTMLElement>;
      "infobar": React.HTMLAttributes<HTMLElement>;
      "item": React.HTMLAttributes<HTMLElement>;
      "layout": React.HTMLAttributes<HTMLElement>;
      "list": React.HTMLAttributes<HTMLElement>;
      "login": React.HTMLAttributes<HTMLElement>;
      "logo": React.HTMLAttributes<HTMLElement>;
      "media": React.HTMLAttributes<HTMLElement>;
      "message": React.HTMLAttributes<HTMLElement>;
      "name": React.HTMLAttributes<HTMLElement>;
      "overlay": React.HTMLAttributes<HTMLElement>;
      "panel": React.HTMLAttributes<HTMLElement>;
      "pie": React.HTMLAttributes<HTMLElement>;
      "player": React.HTMLAttributes<HTMLElement>;
      "playlist": React.HTMLAttributes<HTMLElement>;
      "point": React.HTMLAttributes<HTMLElement>;
      "pulse": React.HTMLAttributes<HTMLElement>;
      "row": React.HTMLAttributes<HTMLElement>;
      "scroller": React.HTMLAttributes<HTMLElement>;
      "subtitle": React.HTMLAttributes<HTMLElement>;
      "separator": {
        vertical?: string | boolean | undefined;
        horizontal?: string | boolean | undefined;
      } & React.HTMLAttributes<HTMLElement>;
      "space": { 
        horizontal?: string;
      } & React.HTMLAttributes<HTMLElement>;
      "switchable": React.HTMLAttributes<HTMLElement>;
      "tag": React.HTMLAttributes<HTMLElement>;
      "test": React.HTMLAttributes<HTMLElement>;
      "thumb": React.HTMLAttributes<HTMLElement>;
      "thumbs": React.HTMLAttributes<HTMLElement>;
      "tick": React.HTMLAttributes<HTMLElement>;
      "tip": React.HTMLAttributes<HTMLElement>;
      "toolbar": React.HTMLAttributes<HTMLElement>;
      "widget": React.HTMLAttributes<HTMLElement>;
      "wrap": { 
        mini?: string;
        gap?: string;
      } & React.HTMLAttributes<HTMLElement>;
      "wrapper": React.HTMLAttributes<HTMLElement>;
      "zone": React.HTMLAttributes<HTMLElement>;
      "hamburger": React.HTMLAttributes<HTMLElement>;
      "dashboard": React.HTMLAttributes<HTMLElement>;
      "length": React.HTMLAttributes<HTMLElement>;
      "preline": React.HTMLAttributes<HTMLElement>;
      "monospace": React.HTMLAttributes<HTMLElement>;
      "size": React.HTMLAttributes<HTMLElement>;
      "slide": React.HTMLAttributes<HTMLElement>;
      "slider": React.HTMLAttributes<HTMLElement>;
      "material": React.HTMLAttributes<HTMLElement>;
      "infomessage": React.HTMLAttributes<HTMLElement>;
      "fields": React.HTMLAttributes<HTMLElement>;
      "fieldwrap": React.HTMLAttributes<HTMLElement>;
      "decoration": React.HTMLAttributes<HTMLElement>;
      "back": React.HTMLAttributes<HTMLElement>;
      "Tooltip": {
        space?: boolean;
      } & React.HTMLAttributes<HTMLElement>;
    }
  }
}


declare module "react" {
  interface Attributes {
    // extends React's HTMLAttributes
    autocomplete?: string | boolean;
    dashboard?: string | boolean;
    classic?: string | boolean;
    checkbox?: string | boolean;
    simple?: string | boolean;
    minimal?: string | boolean;
    radio?: string | boolean;
    effect?: string;
    border?: string;
    link?: string;
    light?: string | boolean;
    wrap?: string | boolean;
    top?: string;
    tiny?: string;
    fixed?: string | boolean;
    small?: string;
    mini?: string | boolean;
    medium?: string | boolean;
    large?: string | boolean;
    horizontal?: string | boolean;
    intro?: string;
    background?: string;
    space?: string | boolean | number;
    launcher?: string | boolean;
    backdrop?: string;
    resize?: string;
    main?: string;
    icon?: string | React.ReactElement;
    index?: string | number | boolean;
    ref?: any;
    options?: any;
    ellipsis?: string | boolean;
    view?: any;
    decoration?: string;
    accent?: any;
    accent_text?: any;
    vertical?: boolean;
    inputbox?: string;
    preline?: string;
    monospace?: string;
    type?: string;
    editable?: any;
    length?: any;
    //size?: any;
    middle?: any;
    fit?: any;
    fixlength?: string;
    title?: any;
  }
}
